/* BARO theme — theme.js
   No dependencies. Progressive enhancement: every form still works without JS. */
(function () {
  'use strict';
  var T = window.theme || { routes: {}, strings: {} };
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- toast ---------- */
  var toastTimer;
  function toast(msg) {
    var el = $('[data-toast]'); if (!el) return;
    el.textContent = msg; el.classList.add('is-visible');
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 2600);
  }

  /* ---------- drawers ---------- */
  var lastFocus = null;
  function openDrawer(name) {
    var d = $('[data-drawer="' + name + '"]'); if (!d) return false;
    lastFocus = document.activeElement;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    $$('[aria-controls="' + d.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var panel = $('.drawer__panel', d); if (panel) setTimeout(function () { panel.focus(); }, 50);
    return true;
  }
  function closeDrawers() {
    $$('.drawer.is-open').forEach(function (d) {
      d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true');
      $$('[aria-controls="' + d.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    });
    document.body.classList.remove('is-locked');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-drawer-open]');
    if (open) { if (openDrawer(open.getAttribute('data-drawer-open'))) e.preventDefault(); return; }
    if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); closeDrawers(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawers(); return; }
    if (e.key !== 'Tab') return;
    var d = $('.drawer.is-open'); if (!d) return;
    var f = $$('a[href], button:not([disabled]), input:not([disabled]):not([type=hidden]), select, textarea, [tabindex]:not([tabindex="-1"])', d)
      .filter(function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
  });

  /* ---------- announcement rotation ---------- */
  $$('[data-announcement]').forEach(function (bar) {
    var items = $$('.announcement__item', bar); if (items.length < 2) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var i = 0, ms = parseInt(bar.getAttribute('data-interval'), 10) || 5000;
    setInterval(function () { items[i].classList.remove('is-active'); i = (i + 1) % items.length; items[i].classList.add('is-active'); }, ms);
  });

  /* ---------- cart ---------- */
  function sectionsToRender() {
    var ids = [];
    if ($('#CartDrawer')) ids.push('cart-drawer');
    var page = $('[data-cart-section]'); if (page) ids.push(page.getAttribute('data-section-id'));
    return ids;
  }
  function renderSections(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (id) {
      var html = sections[id]; if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      if (id === 'cart-drawer') {
        var fresh = $('[data-cart-drawer-content]', doc), cur = $('[data-cart-drawer-content]');
        if (fresh && cur) cur.innerHTML = fresh.innerHTML;
      } else {
        var freshP = $('[data-cart-section]', doc), curP = $('[data-cart-section]');
        if (freshP && curP) curP.innerHTML = freshP.innerHTML;
      }
    });
  }
  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (el) { el.setAttribute('data-count', count); el.textContent = count > 0 ? count : ''; });
  }
  function refreshCount() {
    return fetch(T.routes.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); }).then(function (c) { updateCount(c.item_count); return c; });
  }
  function addToCart(items, button) {
    if (button) { button.setAttribute('aria-busy', 'true'); button.disabled = true; }
    var body = { items: items, sections: sectionsToRender(), sections_url: window.location.pathname };
    return fetch(T.routes.cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (res) {
        renderSections(res.sections);
        return refreshCount().then(function () {
          if (T.cartType === 'drawer' && $('#CartDrawer')) openDrawer('cart'); else toast(T.strings.added);
        });
      })
      .catch(function (err) { toast((err && (err.description || err.message)) || T.strings.error); })
      .finally(function () { if (button) { button.removeAttribute('aria-busy'); button.disabled = false; } });
  }
  function changeLine(line, quantity) {
    var body = { line: line, quantity: quantity, sections: sectionsToRender(), sections_url: window.location.pathname };
    return fetch(T.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderSections(cart.sections); updateCount(cart.item_count); })
      .catch(function () { toast(T.strings.error); });
  }

  // Product forms (AJAX add with graceful fallback)
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
    if (!window.fetch) return;
    e.preventDefault();
    var fd = new FormData(form);
    var item = { id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1) };
    var btn = $('[data-add-button]', form) || form.querySelector('[type=submit]');
    addToCart([item], btn);
  });

  // Quick add (cards, cart upsells)
  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-quick-add]'); if (!q) return;
    e.preventDefault(); e.stopPropagation();
    addToCart([{ id: Number(q.getAttribute('data-quick-add')), quantity: 1 }], q);
  });

  // Quantity steppers (product form + cart lines)
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty-step]'); if (!step) return;
    var wrap = step.closest('[data-qty]'); var input = $('input', wrap);
    var min = input.hasAttribute('data-line-qty') ? 0 : 1;
    var v = Math.max(min, (parseInt(input.value, 10) || 0) + parseInt(step.getAttribute('data-qty-step'), 10));
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
  var lineTimer;
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-line-qty]'); if (!input) return;
    clearTimeout(lineTimer);
    lineTimer = setTimeout(function () { changeLine(Number(input.getAttribute('data-line-qty')), Math.max(0, parseInt(input.value, 10) || 0)); }, 300);
  });
  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-line-remove]'); if (!rm) return;
    e.preventDefault(); changeLine(Number(rm.getAttribute('data-line-remove')), 0);
  });

  /* ---------- product page ---------- */
  $$('[data-product-section]').forEach(function (section) {
    var jsonEl = $('[data-product-json]', section); if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var form = $('form[action*="/cart/add"]', section);
    var idInput = $('[data-variant-input]', section);
    var addBtn = $('[data-add-button]', section);
    var addLabel = $('[data-add-label]', section);
    var stickyAdd = $('[data-sticky-add]', section);
    var money = function (cents) {
      var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
      try { return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: cur, minimumFractionDigits: cents % 100 ? 2 : 0 }).format(cents / 100); }
      catch (err) { return (cents / 100).toFixed(2); }
    };

    function selectedOptions() {
      return $$('[data-option-index]:checked', section).map(function (i) { return i.value; });
    }
    function onChange() {
      var opts = selectedOptions();
      var variant = product.variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
      opts.forEach(function (val, i) { var l = $('[data-option-selected="' + i + '"]', section); if (l) l.textContent = val; });
      // mark impossible combinations
      $$('[data-option-index]', section).forEach(function (input) {
        var idx = Number(input.getAttribute('data-option-index'));
        var test = opts.slice(); test[idx] = input.value;
        var exists = product.variants.some(function (v) { return v.available && v.options.every(function (o, i) { return o === test[i]; }); });
        input.nextElementSibling.style.opacity = exists ? '' : '.45';
      });
      if (!variant) {
        if (addBtn) addBtn.disabled = true; if (addLabel) addLabel.textContent = T.strings.unavailable; return;
      }
      if (idInput) idInput.value = variant.id;
      var priceAmount = $('[data-product-price] [data-price-amount]', section);
      if (priceAmount) priceAmount.textContent = money(variant.price);
      var compare = $('[data-product-price] [data-price-compare]', section);
      if (compare) compare.textContent = variant.compare_at_price > variant.price ? money(variant.compare_at_price) : '';
      var sp = $('[data-sticky-price]', section);
      if (sp) sp.innerHTML = (product.variants.length > 1 ? '<span>' + variant.title.replace(/</g, '&lt;') + '</span> · ' : '') + money(variant.price);
      if (addBtn) addBtn.disabled = !variant.available;
      if (stickyAdd) stickyAdd.disabled = !variant.available;
      if (addLabel && !addLabel.hasAttribute('data-keep')) addLabel.textContent = variant.available ? (addLabel.getAttribute('data-default') || T.strings.addToCart) : T.strings.soldOut;
      if (variant.featured_media) {
        var item = $('[data-media-id="' + variant.featured_media.id + '"]', section);
        if (item && window.matchMedia('(max-width: 989px)').matches) item.parentNode.scrollTo({ left: item.offsetLeft, behavior: 'smooth' });
      }
      var url = new URL(window.location.href); url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
    if (addLabel) addLabel.setAttribute('data-default', addLabel.textContent.trim());
    $$('[data-option-index]', section).forEach(function (i) { i.addEventListener('change', onChange); });

    // Mobile gallery dots
    var track = $('[data-gallery-track]', section), dots = $$('[data-gallery-dots] button', section);
    if (track && dots.length) {
      dots.forEach(function (d) { d.addEventListener('click', function () { var item = track.children[Number(d.getAttribute('data-index'))]; track.scrollTo({ left: item.offsetLeft, behavior: 'smooth' }); }); });
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          var idx = Array.prototype.indexOf.call(track.children, en.target);
          dots.forEach(function (d, i) { d.setAttribute('aria-current', i === idx ? 'true' : 'false'); });
        });
      }, { root: track, threshold: 0.6 });
      Array.prototype.forEach.call(track.children, function (c) { io.observe(c); });
    }

    // Sticky add to cart (mobile): visible once the main buy area scrolls out of view
    var sticky = $('[data-sticky-atc]', section), buy = $('.buy', section);
    if (sticky && buy && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var past = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', past);
        sticky.setAttribute('aria-hidden', past ? 'false' : 'true');
        $$('a, button', sticky).forEach(function (el) { el.tabIndex = past ? 0 : -1; });
      }).observe(buy);
    }
  });

  /* ---------- related products ---------- */
  if (window.customElements && !customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', class extends HTMLElement {
      connectedCallback() {
        var self = this; if (self.children.length) return;
        new IntersectionObserver(function (entries, obs) {
          if (!entries[0].isIntersecting) return; obs.disconnect();
          fetch(self.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = doc.querySelector('product-recommendations');
            if (fresh && fresh.innerHTML.trim()) self.innerHTML = fresh.innerHTML;
          });
        }, { rootMargin: '0px 0px 400px 0px' }).observe(self);
      }
    });
  }

  /* ---------- collection filters + sorting ---------- */
  function applyFacets(form) {
    var params = new URLSearchParams();
    new FormData(form).forEach(function (v, k) { if (v !== '') params.append(k, v); });
    var sort = $('[data-sort-select]'); if (sort) params.set('sort_by', sort.value);
    window.location.search = params.toString();
  }
  var facetTimer;
  $$('[data-facet-form]').forEach(function (form) {
    var instant = form.id === 'FacetsDesktop';
    form.addEventListener('change', function () {
      if (!instant) return;
      clearTimeout(facetTimer); facetTimer = setTimeout(function () { applyFacets(form); }, 400);
    });
    form.addEventListener('submit', function (e) { e.preventDefault(); applyFacets(form); });
  });
  var sortSelect = $('[data-sort-select]');
  if (sortSelect) sortSelect.addEventListener('change', function () {
    var form = $('#FacetsDesktop') || $('[data-facet-form]');
    if (form) { applyFacets(form); return; }
    var url = new URL(window.location.href); url.searchParams.set('sort_by', sortSelect.value); window.location.href = url.toString();
  });

  /* ---------- cart note ---------- */
  var noteTimer;
  document.addEventListener('input', function (e) {
    var n = e.target.closest('[data-cart-note]'); if (!n) return;
    clearTimeout(noteTimer);
    noteTimer = setTimeout(function () {
      fetch(T.routes.cart + '/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: n.value }) });
    }, 500);
  });
})();
